import { ProfileGroupUserFlagValueEnum } from 'src/shared/models/enums/profileGroupUserFlagValue.enum';

export const UserFlagOptions = [
  { label: 'memberProfile:createProfile.userOrganization', value: ProfileGroupUserFlagValueEnum.organization },
  { label: 'memberProfile:createProfile.userDistrict', value: ProfileGroupUserFlagValueEnum.district },
  { label: 'memberProfile:createProfile.userAssociation', value: ProfileGroupUserFlagValueEnum.association },
];
